import { useStripeAppearance } from "@/modules/payment/hooks/useStripeAppearance"
import type { UserProgramDetailsEntity } from "@/modules/programs/entities/userProgramDetailsEntity"
import { CheckoutProvider } from "@stripe/react-stripe-js/checkout"
import type { Stripe } from "@stripe/stripe-js"
import { CustomCheckoutForm } from "./customCheckoutForm"

type CustomCheckoutContainerProps = {
  stripePromise: Stripe
  clientSecret: string
  program?: UserProgramDetailsEntity
  className?: string
  onCompleteCheckout?: () => void
} & React.ComponentProps<"div">

export function CustomCheckoutContainer({
  clientSecret,
  stripePromise,
  program,
  className,
  onCompleteCheckout,
  ...props
}: CustomCheckoutContainerProps) {
  const appearance = useStripeAppearance()

  return (
    <CheckoutProvider
      stripe={stripePromise}
      options={{
        clientSecret,
        elementsOptions: {
          appearance,
        },
      }}
    >
      <CustomCheckoutForm program={program} className={className} onCompleteCheckout={onCompleteCheckout} {...props} />
    </CheckoutProvider>
  )
}
